// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file admin_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AuthResponseSchema } from "./auth_pb";
import { file_auth } from "./auth_pb";
import type { IdRequestSchema, MessageResponseSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { OrganizationCreateSchema, OrganizationListRequestSchema, OrganizationListSchema, OrganizationSchema, OrganizationUpdateSchema } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { InviteUserRequestSchema, InviteUserResponseSchema, UserCreateSchema, UserListRequestSchema, UserListSchema, UserSchema, UserUpdateSchema } from "./user_pb";
import { file_user } from "./user_pb";

/**
 * Describes the file admin_service.proto.
 */
export const file_admin_service: GenFile = /*@__PURE__*/
  fileDesc("ChNhZG1pbl9zZXJ2aWNlLnByb3RvEglyYWNjb29uYWky9gUKDEFkbWluU2VydmljZRJOChJDcmVhdGVPcmdhbml6YXRpb24SHS5yYWNjb29uYWkuT3JnYW5pemF0aW9uQ3JlYXRlGhcucmFjY29vbmFpLk9yZ2FuaXphdGlvbiIAElYKEUxpc3RPcmdhbml6YXRpb25zEiIucmFjY29vbmFpLk9yZ2FuaXphdGlvbkxpc3RSZXF1ZXN0GhsucmFjY29vbmFpLk9yZ2FuaXphdGlvbkxpc3QiABJOChJVcGRhdGVPcmdhbml6YXRpb24SHS5yYWNjb29uYWkuT3JnYW5pemF0aW9uVXBkYXRlGhcucmFjY29vbmFpLk9yZ2FuaXphdGlvbiIAEjYKCkNyZWF0ZVVzZXISFS5yYWNjb29uYWkuVXNlckNyZWF0ZRoPLnJhY2Nvb25haS5Vc2VyIgASNgoKVXBkYXRlVXNlchIVLnJhY2Nvb25haS5Vc2VyVXBkYXRlGg8ucmFjY29vbmFpLlVzZXIiABJCCg9JbXBlcnNvbmF0ZVVzZXISFC5yYWNjb29uYWkuSWRSZXF1ZXN0GhcucmFjY29vbmFpLkF1dGhSZXNwb25zZSIAEj4KCUxpc3RVc2VycxIaLnJhY2Nvb25haS5Vc2VyTGlzdFJlcXVlc3QaEy5yYWNjb29uYWkuVXNlckxpc3QiABJQChpQb3B1bGF0ZURlZmF1bHRQZXJtaXNzaW9ucxIULnJhY2Nvb25haS5JZFJlcXVlc3QaGi5yYWNjb29uYWkuTWVzc2FnZVJlc3BvbnNlIgASWwolU2V0RGVmYXVsdFJvbGVzVG9BbGxPcmdhbml6YXRpb25Vc2VycxIULnJhY2Nvb25haS5JZFJlcXVlc3QaGi5yYWNjb29uYWkuTWVzc2FnZVJlc3BvbnNlIgASSwoKSW52aXRlVXNlchIcLnJhY2Nvb25haS5JbnZpdGVVc2VyUmVxdWVzdBodLnJhY2Nvb25haS5JbnZpdGVVc2VyUmVzcG9uc2UiAEIGWgQuL3Bi", [file_auth, file_general, file_organization, file_user]);

/**
 * @generated from service raccoonai.AdminService
 */
export const AdminService: GenService<{
  /**
   * Organization manipulation
   *
   * @generated from rpc raccoonai.AdminService.CreateOrganization
   */
  createOrganization: {
    methodKind: "unary";
    input: typeof OrganizationCreateSchema;
    output: typeof OrganizationSchema;
  },
  /**
   * @generated from rpc raccoonai.AdminService.ListOrganizations
   */
  listOrganizations: {
    methodKind: "unary";
    input: typeof OrganizationListRequestSchema;
    output: typeof OrganizationListSchema;
  },
  /**
   * @generated from rpc raccoonai.AdminService.UpdateOrganization
   */
  updateOrganization: {
    methodKind: "unary";
    input: typeof OrganizationUpdateSchema;
    output: typeof OrganizationSchema;
  },
  /**
   * User manipulation
   *
   * @generated from rpc raccoonai.AdminService.CreateUser
   */
  createUser: {
    methodKind: "unary";
    input: typeof UserCreateSchema;
    output: typeof UserSchema;
  },
  /**
   * @generated from rpc raccoonai.AdminService.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof UserUpdateSchema;
    output: typeof UserSchema;
  },
  /**
   * @generated from rpc raccoonai.AdminService.ImpersonateUser
   */
  impersonateUser: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof AuthResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AdminService.ListUsers
   */
  listUsers: {
    methodKind: "unary";
    input: typeof UserListRequestSchema;
    output: typeof UserListSchema;
  },
  /**
   * Related to permissions
   *
   * @generated from rpc raccoonai.AdminService.PopulateDefaultPermissions
   */
  populateDefaultPermissions: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.AdminService.SetDefaultRolesToAllOrganizationUsers
   */
  setDefaultRolesToAllOrganizationUsers: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * Invite user via registration link
   *
   * @generated from rpc raccoonai.AdminService.InviteUser
   */
  inviteUser: {
    methodKind: "unary";
    input: typeof InviteUserRequestSchema;
    output: typeof InviteUserResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_admin_service, 0);

